import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateAddressProvider } from '../data-provider';
import { CACHE_KEYS } from '../types';

export const useUpdateAddress = () => {
  const queryClient = useQueryClient();

  return useMutation({
    // TODO: fix types
    // @ts-expect-error
    mutationFn: updateAddressProvider,

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [...CACHE_KEYS.all, 'addressBookSearch'],
      });
    },
  });
};
